import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Select from './Select';
import WYSIWYG from '../../../components/forms/redux-form/WYSIWYG';
import AsyncSelect from 'react-select/lib/Async';
import { Link } from 'react-router';
import ClientLocationForm from '../components/ClientLocationForm';

class ClientForm extends React.Component {
  constructor() {
    super();

    this.state = {
      showAddLocationForm: false,
    };

    this.addLocation = this.addLocation.bind(this);
    this.removeLocation = this.removeLocation.bind(this);
  }

  renderParentClientSelect = ({
    meta: { touched, error, warning },
    label,
    input,
    disabled,
    info,
    relatedClients,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          isDisabled={disabled}
          isClearable
          cacheOptions
          defaultOptions
          loadOptions={this.searchClients}
          getOptionValue={option => option.code}
          getOptionLabel={option => option.name}
          placeholder="Type Client Name…"
          menuPlacement="auto"
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onParentChange}
        />
        {(info || relatedClients) && (
          <span>
            <small className="help-block">{info}</small>
            <small className="help-block">{relatedClients}</small>
          </span>
        )}
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onParentChange = val => {
    this.props.change('parent', val);
  };

  renderclientManagerSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          loadOptions={this.searchUsers}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
          placeholder="Type User Name…"
          menuPlacement="top"
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientManagerChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientManagerChange = val => {
    this.props.change('clientManager', val);
  };

  renderField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    help,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
        />
        <small className="help-block">{help}</small>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderWYSIWYG = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <WYSIWYG input={input} />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTextArea = ({ input, label, meta: { touched, error, warning } }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <textarea
          {...input}
          className="form-control"
          placeholder={label}
          rows="5"
          cols="30"
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderSelect = ({
    input,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control">
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchUsers = search => {
    return this.props.searchUsers(search, 'isActive');
  };

  searchClients = search => {
    return this.props.searchClients(search, 'isActive');
  };

  addLocationClick = () =>
    this.setState({ showAddLocationForm: !this.state.showAddLocationForm });

  addLocation = values => {
    const clinicLocations = [
      ...(this.props.formValues.clinicLocations ? this.props.formValues.clinicLocations : {}),
    ];
    const location = { ...values.location, ...values };
    delete location.team;
    clinicLocations.push(location);
    this.props.change('clinicLocations', clinicLocations);
    this.setState({ showAddLocationForm: !this.state.showAddLocationForm });
  };

  removeLocation = (e, idx) => {
    const clinicLocations = [
      ...this.props.formValues.clinicLocations,
    ];
    clinicLocations.splice(idx, 1);
    this.props.change('clinicLocations', clinicLocations);
  };

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      initialValues,
      searchLocations,
      tpaSubGroups,
      isLoading,
      formValues
    } = this.props;
    const hasChildren = initialValues.childs && initialValues.childs.length > 0;
    const hasParent = formValues && formValues.parent;
    let info = null;
    const {
      showAddLocationForm,
    } = this.state;

    let relatedClients = [];
    if (hasChildren) {
      info = 'Client already defined at a higher level in the tree.';
      relatedClients = initialValues.childs.map((e, index) => (
        <React.Fragment key={index}>
          <Link
            className="btn btn-default btn-xs"
            to={`client-manager/client/${e.code}`}
          >
            <i className="fa fa-pencil"></i> {e.name}
          </Link>
          &nbsp;
        </React.Fragment>
      ));
      relatedClients.unshift(<React.Fragment>Children Clients: </React.Fragment>);
    } else if(hasParent) {
      relatedClients.push(<React.Fragment>Parent Client: </React.Fragment>);
      relatedClients.push(<React.Fragment>
        <Link
          className="btn btn-default btn-xs"
          to={`client-manager/client/${formValues.parent.code}`}
        >
          <i className="fa fa-pencil"></i> {formValues.parent.name}
        </Link>
        &nbsp;
      </React.Fragment>);
    }

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Client Information</legend>
          <Field
            className="form-control"
            name="employerCodeDescription"
            component={this.renderField}
            type="text"
            placeholder="Client Name"
            label="Client Name"
          />
          <Field
            className="form-control"
            name="employerCodeNumber"
            component={this.renderField}
            type="text"
            placeholder="Telemetry Unique ID"
            label="Telemetry Unique ID"
            disabled={true}
          />
          <Field
            className="form-control"
            name="employerCode"
            component={this.renderField}
            type="text"
            placeholder="Employer Code"
            label="Employer Code"
            help="Unique Employer group reference ID. A typical expected value would be the Hint Employer/Sponsor ID - com-XXXXXXXXXX."
          />
          <Field
            className="form-control"
            name="groupNumber"
            component={this.renderField}
            type="text"
            placeholder="Insurance Group ID"
            label="Insurance Group ID"
          />
          <Field
            className="form-control"
            name="groupName"
            component={this.renderField}
            type="text"
            placeholder="Insurance Employer Group Name"
            label="Insurance Employer Group Name"
          />
          <Field
            className="form-control"
            name="parent"
            component={this.renderParentClientSelect}
            disabled={hasChildren}
            type="text"
            label="Parent Account"
            info={info}
            relatedClients={relatedClients}
          />
          <Field
            className="form-control"
            name="providerCode"
            component={this.renderField}
            type="text"
            placeholder="Provider Code"
            label="Provider Code"
          />
          <Field
            className="form-control"
            name="billingGroup"
            component={this.renderField}
            type="text"
            placeholder="Billing Group"
            label="Billing Group"
          />
          {/*<Field*/}
          {/*  className="form-control"*/}
          {/*  name="primaryClinic"*/}
          {/*  component={this.renderField}*/}
          {/*  type="text"*/}
          {/*  placeholder="Primary Clinic"*/}
          {/*  label="Primary Clinic"*/}
          {/*/>*/}
          <Field
            className="form-control"
            name="eligibleEmployees"
            component={this.renderField}
            type="text"
            placeholder="Eligible Employees"
            label="Eligible Employees"
          />
          <Field
            className="form-control"
            name="totalEnrollment"
            component={this.renderField}
            type="text"
            placeholder="Total Enrollment"
            label="Total Enrollment"
          />
          <Field
            className="form-control"
            name="status"
            component={Select}
            options={{
              Active: 'Active',
              Inactive: 'Inactive',
            }}
            label="Status"
          />
          <Field
            className="form-control"
            name="startDate"
            component={this.renderField}
            type="text"
            placeholder="Start Date"
            label="Start Date"
            help="Date Format as ‘YYYY-MM-DD THH:MM:SS - ex. 2022-12-01 T00:00:00’"
          />
          <Field
            className="form-control"
            name="renewalDate"
            component={this.renderField}
            type="text"
            placeholder="Renewal Date"
            label="Renewal Date"
            help="Date Format as ‘YYYY-MM-DD THH:MM:SS - ex. 2022-12-01 T00:00:00’"
          />
          <Field
            className="form-control"
            name="tpaSubGroupId"
            component={this.renderSelect}
            type="text"
            label="TPA/Subgroups"
          >
            <option value="0">Select</option>
            {tpaSubGroups &&
              tpaSubGroups.map(el => (
                <option key={el.id} value={el.id}>
                  {el.name}
                </option>
              ))}
          </Field>
        </fieldset>
        <fieldset>
          <legend>Employer</legend>
          <Field
            className="form-control"
            name="employerAbout"
            component={this.renderWYSIWYG}
            type="text"
            placeholder="Employer About"
            label="Employer About"
          />
          <Field
            className="form-control"
            name="employerBillingDescriptionText"
            component={this.renderWYSIWYG}
            type="text"
            placeholder="Employer Billing Description Text"
            label="Employer Billing Description Text"
          />
        </fieldset>
        <fieldset>
          <legend>Address</legend>
          <Field
            className="form-control"
            name="address1"
            component={this.renderField}
            type="text"
            placeholder="Address1"
            label="Address 1"
          />
          <Field
            className="form-control"
            name="address2"
            component={this.renderField}
            type="text"
            placeholder="Address2"
            label="Address 2"
          />
          <Field
            className="form-control"
            name="city"
            component={this.renderField}
            type="text"
            placeholder="City"
            label="City"
          />
          <Field
            className="form-control"
            name="state"
            component={this.renderField}
            type="text"
            placeholder="State"
            label="State"
          />
          <Field
            className="form-control"
            name="zip"
            component={this.renderField}
            type="text"
            placeholder="Zip"
            label="Zip"
          />
          <Field
            className="form-control"
            name="phone1"
            component={this.renderField}
            type="text"
            placeholder="Phone"
            label="Phone"
          />
          <Field
            className="form-control"
            name="fax1"
            component={this.renderField}
            type="text"
            placeholder="Fax"
            label="Fax"
          />
        </fieldset>
        <fieldset>
          <legend>Contacts</legend>
          <Field
            className="form-control"
            name="primaryContactFName"
            component={this.renderField}
            type="text"
            placeholder="Primary Contact First Name"
            label="Primary Contact First Name"
          />
          <Field
            className="form-control"
            name="primaryContactLName"
            component={this.renderField}
            type="text"
            placeholder="Primary Contact Last Name"
            label="Primary Contact Last Name"
          />
          <Field
            className="form-control"
            name="primaryContactEmail"
            component={this.renderField}
            type="text"
            placeholder="Primary Contact Email"
            label="Primary Contact Email"
          />
          <Field
            className="form-control"
            name="primaryContactPhone1"
            component={this.renderField}
            type="text"
            placeholder="Primary Contact Phone"
            label="Primary Contact Phone"
          />
          <Field
            className="form-control"
            name="secondaryContactFName"
            component={this.renderField}
            type="text"
            placeholder="Secondary Contact First Name"
            label="Secondary Contact First Name"
          />
          <Field
            className="form-control"
            name="secondaryContactLName"
            component={this.renderField}
            type="text"
            placeholder="Secondary Contac tLast Name"
            label="Secondary Contact Last Name"
          />
          <Field
            className="form-control"
            name="secondaryContactEmail"
            component={this.renderField}
            type="text"
            placeholder="Secondary Contact Email"
            label="Secondary Contact Email"
          />
          <Field
            className="form-control"
            name="secondaryContactPhone1"
            component={this.renderField}
            type="text"
            placeholder="Secondary Contact Phone"
            label="Secondary Contact Phone"
          />
          <Field
            className="form-control"
            name="salesRep1"
            component={this.renderField}
            type="text"
            placeholder="Sales Rep 1"
            label="Sales Rep 1"
          />
          <Field
            className="form-control"
            name="salesRep2"
            component={this.renderField}
            type="text"
            placeholder="Sales Rep 2"
            label="Sales Rep 2"
          />
          <Field
            className="form-control"
            name="clientManager"
            component={this.renderclientManagerSelect}
            type="text"
            label="Client Relations Manager"
          />
          <Field
            className="form-control"
            name="viShare"
            component={this.renderField}
            type="text"
            placeholder="VI Share"
            label="VI Share"
            maxLength={1}
          />
        </fieldset>
        <fieldset>
          <legend>
            Locations{' '}
            <a
              className={`btn btn-xs btn-default ${
                showAddLocationForm ? 'active' : ''
                }`}
              onClick={this.addLocationClick}
            >
              <i className="fa fa-plus" /> Add Location
            </a>
          </legend>
          {showAddLocationForm && (
            <ClientLocationForm
              searchLocations={searchLocations}
              onSubmit={this.addLocation}
            />
          )}
          {formValues &&
            formValues.clinicLocations &&
            formValues.clinicLocations.length > 0 && (
              <div className="row form-group">
                <div className="col-md-2 control-label">Locations</div>
                <div className="col-md-10">
                  <ul className="list-group">
                    {formValues &&
                    formValues.clinicLocations &&
                    formValues.clinicLocations.map((el, idx) => (
                        <li key={idx} className="list-group-item">
                          <img
                            src="/assets/img/avatars/sunny.png"
                            alt="user"
                            width="20px"
                          />
                          {` `}
                          <strong>{el.siteName} ({el.clinicLocationID})</strong>
                          {` `}
                          <em>{el.isDefault ? 'Default' : ''}</em>
                          {` `}
                          <em>{el.isAnchorTenant ? 'Anchor' : ''}</em>
                          {` `}
                          <a
                            onClick={e => this.removeLocation(e, idx)}
                            className="btn btn-default btn-xs pull-right"
                          >
                            &times;
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            )}
        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.employerCodeNumber) {
    errors.employerCodeNumber = 'Required';
  }
  if (!values.employerCodeDescription) {
    errors.employerCodeDescription = 'Required';
  }
  if (!values.employerCode) {
    errors.employerCode = 'Required';
  }
  //if (!values.groupNumber) {
  //  errors.groupNumber = 'Required';
  //}
  //if (!values.groupName) {
  //  errors.groupName = 'Required';
  //}
  //if (!values.providerCode) {
  //  errors.providerCode = 'Required';
  //}
  //if (!values.billingGroup) {
  //  errors.billingGroup = 'Required';
  //}
  if (!values.primaryClinic) {
    errors.primaryClinic = 'Required';
  }
  //if (!values.eligibleEmployees) {
  //  errors.eligibleEmployees = 'Required';
  //}
  //if (!values.totalEnrollment) {
  //  errors.totalEnrollment = 'Required';
  //}
  //if (!values.viShare) {
  //  errors.viShare = 'Required';
  //}

  return errors;
};

ClientForm = connect(state => ({
  formValues: getFormValues('client')(state),
  initialValues: state.clientmanager.client,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'client' })(ClientForm));
export default ClientForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ClientForm.js